import { useGetPageTitle } from "@/hooks";
import { useT } from "@/i18n";
import { ButtonLink, IconLock } from "@/ui";

import { ErrorPage } from "./ErrorPage";

export const ForbiddenPage = () => {
  const t = useT();
  const getPageTitle = useGetPageTitle();

  return (
    <ErrorPage
      icon={IconLock}
      title={t("general.components.forbiddenPage.title")}
      description={t("general.components.forbiddenPage.description")}
      actions={
        <ButtonLink href="/" size="lg">
          {t("general.components.forbiddenPage.backToHome")}
        </ButtonLink>
      }
      documentTitle={getPageTitle(t("general.components.forbiddenPage.documentTitle"))}
    />
  );
};
